//Write your encrypt function which will accept Json object here

import {JSEncrypt} from "jsencrypt";

export const encryptFunction = (inObject) => {
    const encrypt = new JSEncrypt();
    const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvI09iI3DX4m+kiqPZLhO C8WE8WPRdmszI2RXGfS/Vi9a8vxWcBP+ld6aYKwFBaYo7k2pfLN1QZC9W7S+4iwV XqhLE9LtHFvZ83Th3ZTwgZyKeA5R2P9e1vWG1d7BR0JA3zNejOMUgjhfLY9iEnd8 ofG38Qvc/t/EhWSoWSeMS8c1/YQXIYuva76k91/aPxfoII4gdjVLQsZ1hy0rZH0D 5m4x7lSnZfAsFcNomKP8ut9rh4OlGc3nNnzyBXmkGI70VgMELMf5cSG9qLtSBDRS uRBEEzzAniX0DbMWfTjiX1Cslx4fEjmCDPK8dNgkXZ//5LMb8IhxnsuhyYXBqgE8 GQIDAQAB';
    encrypt.setPublicKey(publicKey);
    console.log(inObject, encrypt);
    return encrypt.encrypt(JSON.stringify(inObject));
}
